import { render, staticRenderFns } from "./SingleFileupload.vue?vue&type=template&id=2773da4e&"
import script from "./SingleFileupload.js?vue&type=script&lang=js&"
export * from "./SingleFileupload.js?vue&type=script&lang=js&"
import style0 from "./SingleFileupload.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports